import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { AsyncCallArgs, useAsyncCall } from "@duosoftbg/nacid-components";
import { getPublicGlobalMessages } from "../../../axios/api/services";
import { CardContent as MuiCardContent } from "@mui/material";
import styled from "styled-components";
import PublicGlobalMessagesSection from "./PublicGlobalMessagesSection";

const MESSAGE_TYPE = {
  INFO: "INFO",
  WARNING: "WARNING",
  IMPORTANT: "IMPORTANT",
};
const CardContent = styled(MuiCardContent)``;

const PublicGlobalMessages = () => {
  const { t } = useTranslation();
  const [infoMessages, setInfoMessages] = useState(null);
  const [warningMessages, setWarningMessages] = useState(null);
  const [importantMessages, setImportantMessages] = useState(null);
  const { asyncCall } = useAsyncCall();

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: getPublicGlobalMessages(),
      processResponseErrors: false,
      onSuccess: (response) => {
        const dbMessages = response.map((e) => {
          return {
            id: e.id,
            name: e.name,
            nameEn: e.nameEn,
            text: e.text,
            textEn: e.textEn,
            type: { id: e.type.id, name: e.type.name, nameEn: e.type.nameEn, typeOrder: e.type.typeOrder },
          };
        });
        if (dbMessages.length !== 0) {
          const infoMessagesCopy = [];
          const warningMessagesCopy = [];
          const importantMessagesCopy = [];
          dbMessages.forEach((row) => {
            if (row.type.id === MESSAGE_TYPE.INFO) {
              infoMessagesCopy.push(row);
            }
            if (row.type.id === MESSAGE_TYPE.WARNING) {
              warningMessagesCopy.push(row);
            }
            if (row.type.id === MESSAGE_TYPE.IMPORTANT) {
              importantMessagesCopy.push(row);
            }
          });
          setInfoMessages(infoMessagesCopy);
          setWarningMessages(warningMessagesCopy);
          setImportantMessages(importantMessagesCopy);
        }
      },
      onError: () => {
        setInfoMessages(null);
        setWarningMessages(null);
        setImportantMessages(null);
      },
    };
    asyncCall(asyncCallArgs);
  }, [asyncCall, t]);

  return (
    <>
      {(infoMessages || warningMessages || importantMessages) && (
        <CardContent style={{ paddingBottom: "0px" }}>
          <PublicGlobalMessagesSection
            messages={importantMessages}
            severity={"error"}
            alertTitleColor={"#ef5350"}
          ></PublicGlobalMessagesSection>

          <PublicGlobalMessagesSection
            messages={warningMessages}
            severity={"warning"}
            alertTitleColor={"#ff9800"}
          ></PublicGlobalMessagesSection>

          <PublicGlobalMessagesSection
            messages={infoMessages}
            severity={"info"}
            alertTitleColor={"#03a9f4"}
          ></PublicGlobalMessagesSection>
        </CardContent>
      )}
    </>
  );
};

export default PublicGlobalMessages;
